import PropTypes from 'prop-types';
import { DataGrid } from '@celltrak/ui-components';

import { procedureListHeaders } from '../../constants';
import { getSelectionToClipboard } from '../../../Common/utils';

import useProcedureList from './hooks';
import styles from './ProcedureList.module.scss';

function ProcedureList({ procedureReports, loading }) {
  const { handleColumnClick, sortByColumn, sortDirection } = useProcedureList();

  return (
    <div className={styles.gridContainer} onMouseUp={getSelectionToClipboard} role="none">
      <DataGrid
        rows={procedureReports}
        headers={procedureListHeaders}
        fullWidth
        loading={loading}
        onColumnClick={handleColumnClick}
        sortByColumn={sortByColumn}
        sortDirection={sortDirection}
      />
    </div>
  );
}

ProcedureList.propTypes = {
  procedureReports: PropTypes.arrayOf(
    PropTypes.shape({
      procedureCode: PropTypes.string,
      procedureName: PropTypes.string,
      programCode: PropTypes.string,
      programName: PropTypes.string,
      aggregatorProcedureCode: PropTypes.string,
      modifiers: PropTypes.string,
      type: PropTypes.string,
      isProcedureCode: PropTypes.bool,
      notes: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
};

ProcedureList.defaultProps = {
  procedureReports: [],
  loading: false,
};

export default ProcedureList;
